import React from 'react'
import UAParser from 'ua-parser-js'

import UserFeedBackLink from './UserFeedbackLink.jsx'
import UserFeedbackModal from './UserFeedbackModal.jsx'

const USER_FEEDBACK_TYPE_PROMPT_WIDGET_ID = 'userFeedback/userFeedbackTypePrompt'

function create (app, config) {
  function dismissFeedbackModal () {
    app.bus.send('layers/hide', { id: USER_FEEDBACK_TYPE_PROMPT_WIDGET_ID })
  }

  async function goCustomerURL () {
    window.open(config.feedbackUrl, '_blank')
    const properties = await getProperties()
    properties.feedbackUrl = config.feedbackUrl
    app.bus.send('appInsights/log', { name: 'userFeedback customerFeedback visited', properties })
  }

  async function submitForm (formData) {
    const properties = await getProperties()
    const { feeling, comments } = formData
    properties.feeling = feeling
    properties.comments = comments
    app.bus.send('appInsights/log', { name: 'userFeedback submission', properties })
  }

  const getInstallId = () => {
    const { installId } = JSON.parse(localStorage.getItem(`ll_installId_${app.config.uuid}`)) || {}
    return installId
  }

  async function getProperties () {
    const shortAccountId = await app.bus.get('venueData/getAccountId')
    const parsedUserAgent = new UAParser().getResult()

    return {
      url: window.location.href,
      installId: getInstallId(),
      instanceName: app.config.name,
      shortAccountId,
      productVersion: app.info.wePkg.version,
      deviceTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      deviceOSName: parsedUserAgent.os.name,
      deviceOSVersion: parsedUserAgent.os.version,
      uiLocale: app.i18n().language,
      browserName: parsedUserAgent.browser.name,
      browserVersion: parsedUserAgent.browser.version,
      webConfigId: app.config.uuid
    }
  }

  async function choseType (type) {
    const properties = await getProperties()
    properties.feedbackType = type
    app.bus.send('appInsights/log', { name: 'userFeedback chose type', properties })
  }

  const init = () => {
    const linkClickHandler = async () => {
      const properties = await getProperties()
      app.bus.send('appInsights/log', { name: 'userFeedback link click', properties })
      app.bus.send('layers/show', { id: USER_FEEDBACK_TYPE_PROMPT_WIDGET_ID })
    }

    app.bus.send('layers/register', {
      id: 'userFeedback/feedbackButton',
      widget: () => <UserFeedBackLink url={config.feedbackUrl || 'https://www.acuitybrands.com/contact'} T={app.gt()} clickHandler={linkClickHandler}/>,
      layoutId: 'feedbackZone',
      isOverlay: true,
      show: true
    })

    app.bus.send('layers/register', {
      id: USER_FEEDBACK_TYPE_PROMPT_WIDGET_ID,
      widget: () => <UserFeedbackModal
        choseType={choseType}
        goCustomerURL={config.feedbackUrl ? goCustomerURL : null}
        onModalDismiss={dismissFeedbackModal}
        submitForm={submitForm}
        T={app.gt()}
        width="340px"
      />,
      layoutId: 'modalWindow',
      layoutName: 'fullscreen',
      isOverlay: true,
      show: false
    })
  }

  return {
    init
  }
}

export {
  create
}
